import * as React from 'react';
import type { SVGProps } from 'react';
import type { IconProps, ForwardedIconComponent } from './types';
const PencilLineFilled = (React.forwardRef<SVGSVGElement, SVGProps<SVGSVGElement> & IconProps>(function PencilLineFilled({
  title,
  titleId,
  size = '1em',
  ...props
}, ref) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" ref={ref} aria-labelledby={titleId} {...props}>
        {title ? <title id={titleId}>{title}</title> : null}
        <g fill="currentColor">
          <path d="M21.51 5.408c1.1-1.1 1.1-2.9 0-4s-2.9-1.1-4 0l-1.31 1.31 4 4 1.31-1.31ZM18.79 8.127l-4-4-9.28 9.28-.01 4.01h4l9.29-9.29ZM0 20.418h24v3H0v-3Z" />
        </g>
      </svg>;
}) as ForwardedIconComponent);
export default PencilLineFilled;